import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//               Отправить запрос на получение контентой части постов
//------------------------------------------------------------------------------
export const getMarketPulse = async (idString) => {
  const url = `${backendUrl}/api/widgets/market-pulse/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try{
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении контентной части постов: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch{
    console.error('Программная ошибка получения контнентой части постов:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx